module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-styled-components/gatsby-browser.js'),
      options: {"plugins":[],"displayName":true,"fileName":true,"minify":true,"namespace":"","transpileTemplateLiterals":true,"topLevelImportPaths":[],"pure":false,"disableVendorPrefixes":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-prismic-previews/gatsby-browser.js'),
      options: {"plugins":[],"repositoryName":"careerskitchen","accessToken":"MC5YdGRqenhJQUFDSUFObFQz.UFYx77-9Le-_ve-_vSFpJu-_vQFB77-977-9Yxvvv73vv718X--_ve-_ve-_ve-_vSLvv73vv73vv73vv70TRw","routes":[{"type":"website_page","path":"/:uid"},{"type":"blog_post","path":"/blog/:uid"}]},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-Q9RGMTWN4P"],"gtagConfig":{"linker":{"domains":["careerskitchen.com","app.careerskitchen.com"]},"anonymize_ip":false},"pluginConfig":{"head":false,"respectDNT":true,"exclude":[],"origin":"https://www.googletagmanager.com","delayOnRouteUpdate":0}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
